import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Image } from '@textbook-api-client/lib/actions/util-types/image.model';
import { ScaledImageHelperService } from "../../services/scaled-image-helper.service";
import { MAX_PERCENT } from "../../../../models/const/utility";
import { OperatingSystem } from "../../../../../external/models/device-info.enum";
import { CSS_SIZE_AUTO, CSS_SIZE_FIT_CONTENT } from "../../../../../external/models/css-consts";
import { ImageScalingDirectionEnum } from "../../../../models/image-scaling-direction.enum";

export enum ImageWrapperRenderType {
  fix,
  proportional,
  fixAndProportional,
  zoom,
}

@Component({
  selector: 'txtb-image-wrapper',
  templateUrl: './image-wrapper.component.html',
  styleUrls: ['./image-wrapper.component.scss'],
  providers: [ScaledImageHelperService],
  standalone: false,
})
export class ImageWrapperComponent implements OnInit, OnChanges {
  @Input() center = true;
  @Input() start = false;
  @Input() imageData: Image | null = null;
  @Input() src: string | any | null = null;
  @Input() alt: string | null = '';
  @Input() fluid = false;
  @Input() fixRender = true;
  @Input() proportionalRender = false;
  @Input() imgSrc: string | null = null;
  @Input() isScrolled: boolean | undefined = false;
  @HostBinding('class.vertical-scroll')
  @Input() verticalScroll: boolean | undefined = false;
  @HostBinding('class.horizontal-scroll')
  @Input() horizontalScroll: boolean | undefined = false;
  @Input() currentDeviceOS: string | null = null;
  @HostBinding('class.scroll-disabled')
  @Input() scrollDisabled = false;
  @Input() imagesScalingEnabled = false;
  @Input() scalingDirection: ImageScalingDirectionEnum = ImageScalingDirectionEnum.AUTO;
  @Input() percentageScale: number | null = null;

  @Output() imageLoad = new EventEmitter<undefined>();

  loaded = false;
  renderType: ImageWrapperRenderType|null = 0;

  readonly scaleImageToWidth$ = this.scaledImageHelperService.scaleImageToWidth$;
  readonly scaleImageToHeight$ = this.scaledImageHelperService.scaleImageToHeight$;
  readonly MAX_PERCENT = MAX_PERCENT;

  @HostBinding('style.width') public width =
    this.currentDeviceOS === OperatingSystem.Mac || this.currentDeviceOS === OperatingSystem.Ios ? CSS_SIZE_AUTO : `${MAX_PERCENT}%`;

  @HostBinding('style.height') public height: string | null =
    this.currentDeviceOS === OperatingSystem.Mac || this.currentDeviceOS === OperatingSystem.Ios ? CSS_SIZE_AUTO : CSS_SIZE_FIT_CONTENT;

  constructor(
    private readonly elRef: ElementRef<HTMLElement>,
    private readonly scaledImageHelperService: ScaledImageHelperService,
  ) {
    this.scaledImageHelperService.init(elRef);
  }

  onImageLoad(img: HTMLImageElement|null): void {
    this.imageLoad.emit();
    this.loaded = true;
    this.scaledImageHelperService.setImage(img);
    this.scaledImageHelperService.setScalingDirection(this.scalingDirection);
  }

  ngOnInit(): void {
    if (this.imageData) {
      this.renderType = ImageWrapperRenderType.zoom;
    } else if (this.fixRender && this.proportionalRender) {
      this.renderType = ImageWrapperRenderType.fixAndProportional;
    } else if (this.proportionalRender) {
      this.renderType = ImageWrapperRenderType.proportional;
    } else if (this.fixRender) {
      this.renderType = ImageWrapperRenderType.proportional;
    } else {
      this.renderType = null;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.src) {
      this.loaded = false;
    }
    if (changes.imagesScalingEnabled) {
      this.height = this.imagesScalingEnabled ?
        null :
        this.currentDeviceOS === OperatingSystem.Mac || this.currentDeviceOS === OperatingSystem.Ios ? CSS_SIZE_AUTO : CSS_SIZE_FIT_CONTENT
    }
  }
}
